import styled from 'styled-components';

import { ChevronUpIc } from '@dsch/dd-icons';

import { defaultTheme } from 'styled-system';

export const Header = styled.button`
  padding: ${({ theme }) => theme.spacing.M16};
  display: flex;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const HeaderIcon = styled(ChevronUpIc)`
  position: absolute;
  right: ${({ theme }) => theme.spacing.M16};
  color: ${defaultTheme.donedeal.colors.GREY_DARKER};
`;
